import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {AppointmentsService} from '../web-services/appointments.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {Utils} from '../util/utils';

@Component({
  selector: 'app-initial-assessment-report',
  templateUrl: './initial-assessment-report.component.html',
  styleUrls: ['./initial-assessment-report.component.css']
})
export class InitialAssessmentReportComponent implements OnInit {

  letTrue = false;
  displaySummaryDialog = false;

  appointmentId : any;
  assessmentData : any;
  utils = new Utils();
  showAssessment = false;
  constructor(
              public config: DynamicDialogConfig,
              public appointmentsServices: AppointmentsService,
              public loader: NgxUiLoaderService,
  )
  { };

  ngOnInit(): void {
    // this.letTrue = true;
    console.log('Initial Assessment Report called');
    this.appointmentId = this.config.data.appointmentId;
    console.log(this.appointmentId, 'selected appointment Id ');
    this.findInitialAssessmentById();
  }

  findInitialAssessmentById(){
    this.startLoader();
    this.appointmentsServices.getInitialAssessmentReport(this.appointmentId).subscribe(
        res => {
          if (res['message'] == 'Success') {
            this.assessmentData = res['data'][0];
            console.log(this.assessmentData, 'retrieved assessment data ');
            this.showAssessment = true;
            // this.stopLoader();
          } else {
            this.assessmentData = [];
            this.showAssessment = false;
            // this.stopLoader();
          }
          this.stopLoader();
        }, err => {
          console.error('err: ', err);
          // this.showAssessment = false;
          this.stopLoader();
        });
  }

  startLoader() {
    this.loader.start();
  }

  stopLoader() {
    this.loader.stop();
  }

  showSummaryDialog(){
    this.letTrue=true;
  }
  reportData: any[] = [
    {"reportName":"QTFC Grade","reportSummary": "Clinical presentation : Physical and psychological impairments present", },
    {"reportName":"WAD 0","reportSummary": "Client does not complain of painNo physical signs are observed by the examining health care practitioner.", },
    {"reportName":"WAD I","reportSummary": "Client complains of pain to health practitioner.No physical signs are found i.e. normal range of motion strength and no swelling. Small muscle lesions that is not signitifcant enough to cause muscle spasm.", },
    {"reportName":"WAD II","reportSummary": "Client complains of pain to health practitioner.Musculoskeletal signs are found that could include:Limited range of motionSpasm or swellingPoint tenderness in neck or shouldersUsually sustain sprained ligaments and muscle tears.", },
    {"reportName":"WAD III","reportSummary": "Musculoskeletal signs includingNeurological signs including: Decreased or absent deep tendon reflexAltered muscle recruitment patternsMuscle weaknesssensory deficits (mechanical, thermal, ULNT)Usually the clients suffer from injuries to the neurologic system because of pressure on nerves or irritation secondary to sustained stretch of neural tissue.", },
    {"reportName":"WAD IV","reportSummary": "Fracture or dislocation", },
  ];
  classificationTbl: any[] = [
    {"initial":"Classification on initial assessment",
      "post": "Classification post treatment",},
  ];
  therapyList: any[] = [
    {"theadings":"Client Name:","name": "Imran Choudhry",},
    {"theadings":"Therapist:","name": "Raymond Parker",},
  ];

  getLov(name) {

    if(name){
      return name.map(d => d.lovValues ).join(',');
    } else {
      return '';
    }
  }

  checkUndefined(assessmentData, name) {

    if(assessmentData && assessmentData.name && assessmentData.name.length>0){
      // if(assessmentData.name.length>0){
        return assessmentData.name
      // }
    }
  }
}
